import { render, staticRenderFns } from "./DesktopSkinA.vue?vue&type=template&id=256354ec&"
import script from "./DesktopSkinA.vue?vue&type=script&lang=js&"
export * from "./DesktopSkinA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports